import { createElementBlock as l, openBlock as o, createElementVNode as i, defineComponent as p, resolveComponent as t, createBlock as d, createSlots as m, withCtx as n, createVNode as f, renderSlot as u } from "vue";
import _ from "./Input-KouLK2QK.js";
import { _ as g } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function w(e, r) {
  return o(), l("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    i("path", {
      "fill-rule": "evenodd",
      d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const h = p({
  components: { TInput: _, MagnifyingGlassIcon: w },
  slots: Object
});
function v(e, r, x, I, $, y) {
  const c = t("MagnifyingGlassIcon"), s = t("TInput");
  return o(), d(s, { debounce: 600 }, m({
    start: n(() => [
      f(c, { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" })
    ]),
    _: 2
  }, [
    "end" in e.$slots ? {
      name: "end",
      fn: n(({ focused: a }) => [
        u(e.$slots, "end", { focused: a })
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const C = /* @__PURE__ */ g(h, [["render", v]]);
export {
  C as default
};
//# sourceMappingURL=InputSearch-DPusY0z8.js.map
